

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';
import ToolBar from '@/components/common/gis/toolbar/ToolBar.vue';
import LayoutGisPlot from '@/views/plot/LayoutGisPlot.vue';
import LayoutThematicMap from '@/views/thematicMap/LayoutThematicMap.vue';
import TrafficPanel from '@/views/toolbar/TrafficPanel.vue';
import { toolbarList, plotConfig } from './Config';
import { clickHander } from '@/views/toolbar/ToolBarHandler';

@Component({
  name: 'LayoutToolBar',
  components: {
      ToolBar,
      LayoutGisPlot,
      LayoutThematicMap,
      TrafficPanel,
  },
  mixins: [MapResolver],
})
export default class LayoutToolBar extends Vue {
  @Injectable() public container!: Container;
  private cityListName: any = '全国';
  /**
   * 工具条数据
   */
  private toolbarDatas: any = toolbarList;
  private plotOptions: any = plotConfig;
  private thematicOptions = {
      mapId: 'map',
  };
  private isShowThematic: boolean = false;
  private isShowTraffic: boolean = false;
  constructor() {
    super();
  }

  // 打开标绘工具箱
  public showPlot() {
      (this.$refs as any).gisPlot.plotOpen();
  }
  // 专题制图
  private closeThematic() {
      this.isShowThematic = false;
  }
  private trafficCloseClick() {
      this.toolbarDatas.forEach((ele: any) => {
          ele.selected = false;
      });
      this.isShowTraffic = false;

  }
  // 城市点击后与gis互动
  private async cityItemClick(item: any) {
      const component: any = await this.getComponent('Search', 'DistrictSearch');
      if (item) {
          component.panToCity(item);
      } else {
          component.fitChina();
      }
  }

  private async clickItem(item: any) {
      const key: string = item.key;
      const params: any = {};
      params.context = this;
      params.toolComponent = await this.getComponent();
      clickHander[key](item, params);
  }


  private async initMapEvents() {
        const component: any = await this.getComponent('Toolbar', 'RegeoCode');
        component.off('drag');
        component.on('drag', (data: any) => {
          if (data === '1') {
              this.cityListName = '全国';
          } else {
              this.cityListName = data;
          }
        });


      // 二三维切换，全局通知
        const notify = this.container.resolve('notify');
        notify.on('dimension-changed', (d: any) => {
             if (d === '2d') {
                 this.toolbarDatas.forEach((ele: any) => {
                     ele.selectable = false;
                 });


             } else {
                 this.toolbarDatas.forEach((ele: any) => {
                     ele.selectable = false;
                     if (ele.key === 'streetBar' || ele.key === 'realtime-traffic') {
                         ele.selectable = true;
                     }
                 });
             }
          }, this,
      );
  }

  private async created() {
      this.initMapEvents();

  }

      private getComponent(moduleName: string = 'Toolbar', componentName: string = 'GISToolComponent') {
        const p = new Promise((resolve, reject) => {
            (this as any).resolveMap('map').then((data: any) => {
                const temp: any = this;
                const facotory = temp.container.resolve('mapShare').comFactory;
                const component = facotory.getComponent(moduleName, componentName);
                resolve(component);
            }).catch(() => { reject('获取地图组件失败'); });
        });
        return p;
    }
}
